import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from '../services/users/users.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-shared-result',
    templateUrl: './shared-result.component.html',
    styleUrls: ['./shared-result.component.scss'],
})
export class SharedResultComponent implements OnInit {
    selectedResult: any = null;
    loading = false;
    message: string | null = null;
    token: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private usersService: UsersService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.route.queryParamMap.subscribe((params) => {
            this.token = params.get('token');

            if (!this.token) {
                this.message = 'Link invalid: lipsește token-ul.';
                this.selectedResult = null;
                return;
            }

            this.loadSharedResult(this.token);
        });
    }

    loadSharedResult(token: string): void {
        this.loading = true;
        this.message = 'Se încarcă rezultatul medical...';
        this.selectedResult = null;

        this.usersService.getSharedResult(token).subscribe({
            next: (data: any) => {
                this.selectedResult = data;
                this.loading = false;
                this.message = null;
            },
            error: (err) => {
                console.error('Shared result error', err);
                this.loading = false;
                this.selectedResult = null;
                this.message =
                    'Rezultatul nu a putut fi încărcat. Link invalid, expirat sau indisponibil.';
                this.toastr.error(this.message, 'Rezultat medical');
            },
        });
    }


    getStatusLabel(status: any): string {
        return status ? 'Finalizat' : 'În lucru';
    }

    getHospitalName(): string {
        return this.selectedResult?.hospitalName || 'Spital CF Pașcani';
    }

    getPatientName(): string {
        return this.selectedResult?.patientName || '-';
    }
}